<template>
  <div class="full-height">
    <article class="slds-card">
      <Spinner v-if="loading" />

      <div v-else>
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__figure">
              <span class="slds-icon_container slds-icon-standard-user" :title="$t('sections.campaignMonitoring')">
                <svg class="slds-icon slds-icon-action-user" aria-hidden="true">
                  <use xlink:href="../assets/symbols.svg#list"></use>
                </svg>
              </span>
            </div>
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span class="slds-card__header-link slds-truncate" :title="$t('sections.campaignMonitoring')">
                  <span>{{$t('sections.campaignMonitoring')}}</span>
                </span>
              </h2>
            </div>
          </header>
        </div>
      </div>
    </article>

    <Card additional-classes="slds-m-top-small" v-if="messages.length">
      <ul class="slds-has-dividers_bottom-space">
        <li class="slds-item" v-for="(message, index) in messages" :key="index">{{message.time}} - {{message.message}}</li>
      </ul>
    </Card>
  </div>
</template>
<script>
import { subscribeToGenericLogs, unsubscribeToGenericLogs } from '../components/utils/socketUtils'
import Card from '../components/slds/Card'
import Spinner from '../components/Spinner'

export default {
  components: {
    Card,
    Spinner
  },
  data () {
    return {
      socket: undefined,
      loading: false,
      messages: []
    }
  },
  mounted () {
    this.socket = subscribeToGenericLogs((msg) => { this.messages.push(JSON.parse(msg)) })
  },
  beforeDestroy () {
    unsubscribeToGenericLogs(this.socket)
  }
}
</script>
<style lang="scss" scoped>
  .full-height {
    height: 100%;
  }
</style>
